import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=199ae644"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199ae644')) {
      api.createRecord('199ae644', component.options)
    } else {
      api.reload('199ae644', component.options)
    }
    module.hot.accept("./Post.vue?vue&type=template&id=199ae644", function () {
      api.rerender('199ae644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/community/Post.vue"
export default component.exports